module.exports = __webpack_public_path__ + "static/fowf-advisor-2-d9c4b938f0cd00fc0a0002a302c718db.jpg";